import FileCountBadgeContainer from './FileCountBadgeContainer'
import FileCountBadge from './FileCountBadge'
export { FileCountBadge }
export { FileCountBadgeContainer }
export default FileCountBadgeContainer



// WEBPACK FOOTER //
// ./src/components/FileCountBadge/index.js